import React from "react";
import TokenTransferStep, {
  TokenTransferStepProps,
} from "../../TokenTransferStep";
import ForgotPassphraseTermsCheckbox from "./LegalTermsCheckbox";
import { useController } from "react-hook-form";
import { TokenTransferRequestFieldNames } from "../../../hooks/constants";
import { ModalHeader } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalHeader";
import { ModalBody } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalBody";
import TokenTransferConfirmationDetails from "../../TokenTransferConfirmationDetails";
import FAQsLink from "../../FAQsLink";
import TokenTransferStepButton from "../../TokenTransferStepButton";
import { Body5 } from "@/src/components/typography/components/Body";
import { Legal4 } from "@/src/components/typography/components/Legal";

export default function ReviewDetails({
  isShowing = false,
  token,
}: TokenTransferStepProps) {
  const {
    field: { value: walletAddress },
  } = useController({
    name: TokenTransferRequestFieldNames.walletAddress,
  });

  const {
    field: { value: checkedAgreement },
  } = useController({
    name: TokenTransferRequestFieldNames.legalAgreement,
  });

  return (
    <TokenTransferStep isShowing={isShowing}>
      <ModalHeader>Review Details</ModalHeader>

      <ModalBody className="flex flex-col gap-6">
        <BodyCopy />

        <ForgotPassphraseTermsCheckbox />

        <TokenTransferConfirmationDetails
          token={token}
          address={walletAddress}
        />
        <FAQsLink />
        <TransferDetailCopy />

        <TokenTransferStepButton type="submit" disabled={!checkedAgreement}>
          Transfer
        </TokenTransferStepButton>
      </ModalBody>
    </TokenTransferStep>
  );
}

function BodyCopy() {
  return (
    <Body5>
      Your Nike Virtual Creation will now be transferred into your wallet of
      choice. This action cannot be reversed—please double check the wallet
      address!
    </Body5>
  );
}

function TransferDetailCopy() {
  return (
    <Legal4 className="laptop:text-center text-gray-500">
      This action cannot be reversed - please double check the wallet address
    </Legal4>
  );
}
